import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  RoutingState,
  contactsRoute,
  distributionRoute,
  homeRoute,
} from "@models/routing.model";

export const initialState: RoutingState = {
  contacts: contactsRoute.persons,
  distribution: distributionRoute.leads,
  home: homeRoute.dashboard,
};

const routingPersistConfig = {
  key: "routing",
  storage,
};

export const routingSlice = createSlice({
  name: "routing",
  initialState,
  reducers: {
    setContactsRoute: (state, action: PayloadAction<contactsRoute>) => {
      state.contacts = action.payload;
    },
    setDistributionRoute: (state, action: PayloadAction<distributionRoute>) => {
      state.distribution = action.payload;
    },
    setHomeRoute: (state, action: PayloadAction<homeRoute>) => {
      state.home = action.payload;
    },
  },
});

export const { setContactsRoute, setDistributionRoute, setHomeRoute } =
  routingSlice.actions;

export default persistReducer(routingPersistConfig, routingSlice.reducer);
